import moment from 'moment'
import {calculateDate} from '../../../../utils'
import {ListHealthInsuranceInitialStateModel} from '../model/HealthInsuranceState'
import {UserInfoModel} from '../model/UserInfoModel'

export const initialState: ListHealthInsuranceInitialStateModel = [
  {
    tabName: undefined,
    sellingContractId: undefined,
    customerCode: undefined,
    customerVersion: undefined,
    groupDomainCode: undefined,
    contractType: undefined,
    contractKind: undefined,
    originalContract: undefined,
    addressName: undefined,
    customerName: undefined,
    customerBirthDay: undefined,
    gender: undefined,
    phone: undefined,
    mobile: undefined,
    email: undefined,
    customerType: undefined,
    customerSegment: undefined,
    identificationNumber: undefined,
    taxNumber: undefined,
    packageExtension: undefined,
    packageInsurance: undefined,
    form: {
      activeForm: 1,
      formStatus: null,
      packageCodeView: null,
      packageConditional: null,
      formData: {
        formPersonInsurancePlan: {
          businessProgramCode: null,
          productCode: null,
          exploitingType: null,
          exploitingCode: null,
          typeOfIntroduction: null,
          introductionCode: null,
          curencyMoney: null,
          curencyFee: null,
          exchangeRate: '1',
          exchangeRateNote: null,
          business: null,
          businessName: null,
          paymentTimeType: '0',
          calculationType: '0',
          nationality: null,
          currencyFeeChange: null,
          validateForm: null,
          tpa: null,
          tpaType: null,
          tpaFee: null,
          adjacentContractNumberLoss: null,
          adjacentContractNumber: null,
          paymentTimeDay: null,
          amountPeople: null,
          commission: '0',
          adminFee: '0',
          taxType: null,
        },
        formPersonOfferFee: {
          id: null,
          packageCode: null,
          name: null,
          code: null,
          salary: '0',
          startDate: moment().format('YYYY/MM/DD'),
          expireDate: calculateDate(moment().format('YYYY/MM/DD'), false),
          amountPeople: 1,
          _sellingContractPeoplePackageBenefitDtos: null,
          _sellingContractPeoplePackageExtensionDtos: null,
          _sellingContractPeoplePackageWaitingDtos: [],
          _sellingContractPeoplePackageNoteDtos: [],
          packageInsuredType: null,
          approveRate: null,
          lossRatio: null,
          validateForm: null,
          coverage: null,
          packagesType: null,
          contractPackageType: null,
          validateCalculateFee: false,
          listObjectSelected: null,
          fieldInput: [],
          oldPackageCode: null,
          codeOption: null,
        },
        formPersonListUser: {
          id: null,
          customerName: null,
          customerCode: null,
          customerVersion: null,
          code: null,
          identificationNumber: null,
          customerBirthDay: null,
          addtionalBenefit: null,
          objectInsuredType: null,
          gender: null,
          packageCode: null,
          coverage: 'Viet Nam',
          mobile: null,
          email: null,
          startDate: moment().format('YYYY/MM/DD HH:mm'),
          expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
          salary: null,
          oldContractCode: null,
          oldContractExitDate: null,
          relationsShip: null,
          addressName: null,
          partner: null,
          position: null,
          employeeCode: null,
          creditContractNumber: null,
          payeeName: null,
          payeeNameIdentificationNumber: null,
          payeesRelationsShip: null,
          note: null,
          validateForm: null,
          listUser: null,
          totalRowList: null,
          packageChosed: null,
          listObjectSelected: null,
          lossRatioRate: null,
          fieldInput: [],
          nationality: null,
          cmtReference: null,
          endorStartDate: null,
          endorExpireDate: null,
          loanAmount: null,
        },
        formPersonContract: {
          agency: null,
          contractType: null,
          contractNumber: null,
          originalCode: null,
          created: null,
          purchaseDate: null,
          dateMoF: null,
          startDate: null,
          expireDate: null,
          manager: null,
          totalPerson: null,
          sumFee: null,
          partyARepresentative: null,
          partyAPosition: null,
          partyBRepresentative: null,
          partyBPosition: null,
          partyBPhone: null,
          partyAPhone: null,
          partyAPowerOfAttorney: null,
          partyBPowerOfAttorney: null,
          lossRatio: null,
          partyBFax: null,
          proxy: null,
          bankCode: null,
          sumTax: null,
          taxType: null,
          bankNumber: null,
          _sellingContractPaymentScheduleDtos: null,
          _sellingContractExtraDataDtos: null,
          _listContractPackages: null,
          validateForm: null,
          exploName: null,
          exploManager: null,
          exploitingType: null,
          tsIncharge: null,
          pmIncharge: null,
          paymentTimeType: null,
          commission: '0',
          adminFee: '0',
          vatAdminFee: null,
          endorStartDate: null,
          endorExpireDate: null,
          userReceiveMail: null,
          customerConfirmDate: null,
          endorNote: null,
          dateDiff: null,
          numberOfPaymentSchedule: null,
        },
      },
    },
  },
]

export const userInitialState: UserInfoModel = {
  id: '',
  customerType: null,
  identificationNumber: null,
  customerCode: null,
  name: null,
  birthday: null,
  gender: null,
  addressName: null,
  addressNameEn: null,
  province: null,
  district: null,
  subDistrict: null,
  phone: '',
  mobile: null,
  email: null,
  bank: null,
  bankNumber: null,
  customerSource: 1,
  parentGroupCode: null,
  employeeCode: null,
  customerSegment: 15,
  position: null,
  taxNumber: '',
  representative: '',
  fax: '',
  companyName: '',
  companyNameEn: '',
  contacts: null,
  nationality: '',
  customerVersion: null,
  dataTableUser: undefined,
  validateFormUser: null,
  staffCode: null,
  aliasName: null,
  shortName: null,
  isChangeData: null,
}
